import { HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD, HIDDENENDPOINTS_CUSTOMEREMAIL_SET } from '../actionDefinitions';
import { createReducer } from '../reducerUtils';

export const initialState = {};

const handlers = {
    [HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD]: (state, action) => {
        if (action.error) {
            return { error: action.payload };
        }
        return { dbCustomerEmails: action.payload.Result };
    },
    [HIDDENENDPOINTS_CUSTOMEREMAIL_SET]: (state, action) => {
        if (action.error) {
            return { error: action.payload };
        }
        return { dbCustomerEmails: action.payload.Result };
    }
};

export default createReducer(initialState, handlers);
